module.exports = __webpack_public_path__ + "img/paris-hilton-2025-s.6df95784.webp";